import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=b882cdb8&scoped=true"
import script from "./chart.vue?vue&type=script&lang=js"
export * from "./chart.vue?vue&type=script&lang=js"
import style0 from "./chart.vue?vue&type=style&index=0&id=b882cdb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b882cdb8",
  null
  
)

export default component.exports